import _extends from '@babel/runtime/helpers/extends';
import _slicedToArray from '@babel/runtime/helpers/slicedToArray';
import * as React from 'react';
import { ClassName } from '../../util/interactiveState.js';
import useForwardedRef from '../../util/useForwardedRef.js';
import { Icon } from '../Icon/Icon.js';
import '../NotificationBadge/index.js';
import { Popover } from '../Popover/Popover.js';
import { Typography } from '../Typography/Typography.js';
import { BaseChip } from './BaseChip.js';
import { mapLeadingIcon, mapNotificationBadge, mapDropdown, mapBaseChipProps, mapLabel } from './FilterChip.mappers.js';
import { NotificationBadge as NotificationBadgeMemoized } from '../NotificationBadge/NotificationBadge.js';

/** Chip (Filter variant) allows users to filter content. */
var FilterChip = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var label = props.label,
    state = props.state,
    size = props.size,
    active = props.active,
    zIndex = props.zIndex,
    flex = props.flex,
    onBlur = props.onBlur,
    onVisibilityChange = props.onVisibilityChange,
    children = props.children;
  var _React$useState = React.useState(active),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    popoverVisible = _React$useState2[0],
    setPopoverVisible = _React$useState2[1];
  var chipRef = useForwardedRef(ref);
  var onPopoverVisibilityChange = React.useCallback(function (visible) {
    setPopoverVisible(visible);
    onVisibilityChange === null || onVisibilityChange === void 0 || onVisibilityChange(visible);
  }, [onVisibilityChange]);
  React.useEffect(function () {
    return setPopoverVisible(active);
  }, [active]);
  React.useEffect(function () {
    var _chipRef$current;
    (_chipRef$current = chipRef.current) === null || _chipRef$current === void 0 || _chipRef$current.classList.toggle(ClassName.Active, active);
  }, [chipRef, active]);
  var leadingIconProps = mapLeadingIcon(props);
  var notificationBadgeProps = mapNotificationBadge(props);
  var dropdownProps = mapDropdown(props);
  var chip = /*#__PURE__*/React.createElement(BaseChip, _extends({
    "aria-expanded": popoverVisible,
    state: state,
    size: size
  }, mapBaseChipProps(props), {
    ref: chipRef
  }), leadingIconProps && /*#__PURE__*/React.createElement(Icon, leadingIconProps), notificationBadgeProps && /*#__PURE__*/React.createElement(NotificationBadgeMemoized, notificationBadgeProps), /*#__PURE__*/React.createElement(Typography, mapLabel(props), label), dropdownProps && /*#__PURE__*/React.createElement(Icon, dropdownProps));
  if (React.Children.count(children) === 0) return chip;
  return /*#__PURE__*/React.createElement(Popover, {
    content: children,
    zIndex: zIndex || 'auto',
    flex: flex,
    visible: popoverVisible,
    interaction: "click",
    onBlur: onBlur,
    onVisibilityChange: onPopoverVisibilityChange
  }, chip);
});
FilterChip.defaultProps = {
  counter: 0,
  active: false,
  dropdown: true
};
var FilterChipMemoized = /*#__PURE__*/React.memo(FilterChip);
FilterChipMemoized.displayName = 'FilterChip';

export { FilterChipMemoized as FilterChip, FilterChip as FilterChipWithoutMemoized };
//# sourceMappingURL=FilterChip.js.map
